import * as React from "react";
import { Box, VStack } from "@chakra-ui/react";

/**
 * Illustrates the use of children prop and spread operator
 */
const FullScreenSection = ({
  children,
  isDarkBackground,
  fullHeight = false,
  contentMaxWidth = "1120px",
  backgroundColor,
  backgroundImage,
  ...boxProps
}) => {
  return (
    <Box
      as="section"
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      color={isDarkBackground ? "white" : "black"}
    >
      <VStack
        width="100%"
        maxWidth={contentMaxWidth}
        margin="0 auto"
        minHeight={fullHeight ? "100svh" : undefined}
        {...boxProps}
      >
        {children}
      </VStack>
    </Box>
  );
};

export default FullScreenSection;
